import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../reduxStore';
import { hideLoader, showLoader } from './loaderSlice';
import { showErrorSnackbar, showSuccessSnackbar } from './snackbarSlice';
import { t } from 'i18next';
import { confirmProductionProduct } from '../../ApiServices/ProductionPlanServices';
import { handleResponse } from '../../ApiServices/ApiHandler';

export const initialState = {
  value: { totalCount: -1, data: [{}] },
  loading: false,
  error: null,
  selectedValue: null,
  outerValue: [],
  historyValue: { products: [], ingredientId: null },
  rowsPerPage: 10,
  pageNo: 0,
  sortBy: '',
  sortDirection: 0,
  filter: {},
};

const confirmProductionSlice = createSlice({
  name: 'confirmProduction',
  initialState: initialState,
  reducers: {
    clearConfirmProductionState(state: any) {
      state.rowsPerPage = initialState.rowsPerPage;
      state.pageNo = initialState.pageNo;
      state.value = initialState.value;
      state.outerValue = initialState.outerValue;
      state.loading = false;
      state.error = null;
      state.selectedValue = initialState.selectedValue;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      fetchConfirmProducts.fulfilled,
      (state: any, action: any) => {
        state.error = initialState.error;
        state.loading = initialState.loading;
        state.selectedValue = initialState.selectedValue;
        state.value = action?.payload?.data;
        state.pageNo = action?.meta?.arg?.page;
        state.rowsPerPage = action?.meta?.arg?.limit;
        state.filter = action?.meta?.arg;
      }
    );
    builder.addCase(
      fetchConfirmProducts.rejected,
      (state: any, action: any) => {
        state.error = action?.payload?.error?.message;
        state.loading = false;
        state.selectedValue = initialState?.selectedValue;
        state.filter = action?.meta?.arg;
      }
    );
  },
});

export const confirmProductionState = (state: RootState) =>
  state?.confirmProduction;
export const { clearConfirmProductionState } = confirmProductionSlice.actions;
export default confirmProductionSlice.reducer;

export const fetchConfirmProducts = createAsyncThunk(
  'confirmProduction/fetchConfirmProducts',
  async (payload: any, { fulfillWithValue, rejectWithValue, dispatch }) => {
    try {
      dispatch(showLoader({ message: t('FECTING_CONFIRM_PRODUCTION') }));
      let response: any = await confirmProductionProduct(payload);
      // return fulfillWithValue(response);
      if (response?.status === 200 || response === 200) {
        dispatch(
          showSuccessSnackbar({
            message: t('CONFIRM_PRODUCTION_SAVED_SUCCESS'),
          })
        );
        return fulfillWithValue(response);
      } else {
        dispatch(
          showErrorSnackbar({ message: t('CONFIRM_PRODUCTION_SAVE_FAILED') })
        );
        return rejectWithValue(response);
      }
      // return await handleResponse(response, fulfillWithValue, rejectWithValue, dispatch);
    } catch (error) {
      dispatch(showErrorSnackbar({ message: error }));
      return rejectWithValue(error);
    } finally {
      dispatch(hideLoader());
    }
  }
);
